import { Pipe } from '@angular/core';
import { isArray } from '../utils/utils';
var TailPipe = (function () {
    function TailPipe() {
    }
    TailPipe.prototype.transform = function (input) {
        if (!isArray(input)) {
            return input;
        }
        return input.slice(1, input.length);
    };
    return TailPipe;
}());
export { TailPipe };
TailPipe.decorators = [
    { type: Pipe, args: [{
                name: 'tail'
            },] },
];
/** @nocollapse */
TailPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=tail.pipe.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-pipes/esm/array/tail.pipe.js
// module id = 248
// module chunks = 103